export default {
  header: {
    basic: 'NGE0ODkwOTRjMTEzOGE3MjU5M2ZiMGNjMGQwYzNmNmI6MTFiNzUyYTMzZTM0NWExZmE5ODc4NzZkYTYzZTkwMmIxYmY3ZjI2NTdkM2ZhMGQyOTc0NjI2ZTZhMTVmNTExMA==', // eslint-disable-line
    platform: 'web',
    version: '1.0.0',
  },
  timezone: 'America/Sao_Paulo',
  language: 'pt-br',
  noReCaptcha: 'ZGVzZW52b2x2aWRvIHBvciB2aXRhbw==',
  keyReCaptcha: '6Leh4xklAAAAAN9U3Ne4YqEF-NYzzz_pcn5WVjwW',
};
